import { connect } from "react-redux";
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Footer from "./containers/Footer";
import Page from "./containers/Page";
import Sidebar from "./containers/Sidebar";
import SummaryPage from "./containers/SummaryPage";
import { RootState } from "./state/reducers";

interface Pages {
  allIds: (number | string)[];
  byId: any; // TODO: Explicit type.
}

interface AppProps {
  pages: Pages;
}

const App: React.FC<AppProps> = ({ pages }) => {
  const short = (id: number | string | undefined) => {
    if (!id) return "";
    if (!pages.byId[id].short) return "";
    return pages.byId[id].short;
  };
  return (
    <main>
      <Router>
        <Sidebar pages={pages} />
        <Switch>
          {pages.allIds.map((id) => {
            return (
              <Route key={id} exact path={`/${short(id)}`}>
                <Page page={pages.byId[id]} />
              </Route>
            );
          })}
          <Route exact path="/summary">
            <SummaryPage />
          </Route>
          <Redirect to={`/${short(pages.allIds[0])}`} />;
        </Switch>
        <Footer />
      </Router>
    </main>
  );
};

export default connect((store: RootState) => {
  store;
  if (store.formData.entities.pages) {
    return { pages: store.formData.entities.pages };
  } else {
    return { pages: { allIds: [], byId: {} } };
  }
}, {})(App);
